const STORAGE_KEY = 'indicationListState'

const EMPTY_INDICATION_LIST_STATE = {
  activeTab: null,
  filters: {},
  search: '',
}

const safeParse = (raw, fallback) => {
  if (!raw) return fallback
  try {
    return JSON.parse(raw)
  } catch {
    return fallback
  }
}

const sanitizeFilters = (filters) => {
  if (!filters || typeof filters !== 'object') return {}

  return Object.entries(filters).reduce((acc, [key, value]) => {
    if (Array.isArray(value) && value.length > 0) acc[key] = value
    return acc
  }, {})
}

export const loadIndicationListState = (allowedTabs, defaultTab) => {
  const stored = safeParse(sessionStorage.getItem(STORAGE_KEY), EMPTY_INDICATION_LIST_STATE)

  return {
    activeTab: allowedTabs.includes(stored.activeTab) ? stored.activeTab : defaultTab,
    filters: sanitizeFilters(stored.filters),
    search: typeof stored.search === 'string' ? stored.search : '',
  }
}

export const saveIndicationListState = (state) => {
  sessionStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      activeTab: state.activeTab ?? null,
      filters: sanitizeFilters(state.filters),
      search: state.search ?? '',
    }),
  )
}

export const clearIndicationListState = () => {
  sessionStorage.removeItem(STORAGE_KEY)
}
